import { CalendarRange } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import {
  PERIOD_PRESETS,
  PERIOD_PRESET_LABELS,
  type PeriodPreset,
} from '../period'

interface PeriodFilterProps {
  preset: PeriodPreset
  from: string
  to: string
  onPresetChange: (preset: PeriodPreset) => void
  onFromChange: (from: string) => void
  onToChange: (to: string) => void
}

export function PeriodFilter({
  preset,
  from,
  to,
  onPresetChange,
  onFromChange,
  onToChange,
}: PeriodFilterProps) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="space-y-1.5">
        <Label className="flex items-center gap-1.5 text-muted-foreground">
          <CalendarRange className="h-3.5 w-3.5" /> Period
        </Label>
        <Select value={preset} onValueChange={(v) => onPresetChange(v as PeriodPreset)}>
          <SelectTrigger className="w-40">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PERIOD_PRESETS.map((p) => (
              <SelectItem key={p} value={p}>
                {PERIOD_PRESET_LABELS[p]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {preset === 'custom' && (
        <>
          <div className="space-y-1.5">
            <Label className="text-muted-foreground">From</Label>
            <Input
              type="date"
              className="w-40"
              value={from}
              onChange={(e) => onFromChange(e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-muted-foreground">To</Label>
            <Input
              type="date"
              className="w-40"
              value={to}
              onChange={(e) => onToChange(e.target.value)}
            />
          </div>
        </>
      )}
    </div>
  )
}
